import { useAuthContext } from './useAuthContext'
import { useWorkoutsContext } from './useWorkoutsContext'

export const useLogout = () => {
  const { dispatch } = useAuthContext()
  const { dispatch: dispatchWorkouts } = useWorkoutsContext()

  const logout = () => {
    // 🧹 Verwijder alle gebruikersdata
    localStorage.removeItem('user')

    // 🧹 Extra: verwijder transport data zodat TransportProvider niet meer fetcht
    localStorage.removeItem('transportUser');
    localStorage.removeItem('transportToken');
    localStorage.removeItem('transportMode');   // (zie guard hieronder)
    localStorage.removeItem('driver');  

    // 🚪 dispatch logout actions
    dispatch({ type: 'LOGOUT' })
    dispatchWorkouts({ type: 'SET_WORKOUTS', payload: null })
  }

  return { logout }
}
